export default __webpack_public_path__ + "static/media/zhongtai.519fca90.png";